<template>
  <a-modal
    :width="500"
    :maskClosable="false"
    :keyboard="false"
    :visible="visible"
    :footer="null"
    @cancel="visible=false"
  >
    <h2 slot="title" style="text-align:center">识别码查询</h2>
    <div>
        <a-input
            v-model="keywords"
            placeholder="请输入关键词"
            style="width: 80%;margin-right: 10px;"
        ></a-input>
        <a-button @click="search" type="primary">查询</a-button>

        <a-divider></a-divider>
        <div v-for="(item,index) in codeList" :key="index">
          <a-row style="width:400px;margin:auto;">
              <a-col :span="15">机构名：{{item.agent_name}}</a-col>
              <a-col :span="9">识别码：{{item.agent_code}}</a-col>
              <a-col :span="24" v-if="item.category_names">
                适用级别：{{item.category_names}}
              </a-col>
          </a-row>
          <a-divider></a-divider>
        </div>
        
        <p v-if="codeList != null && codeList.length==0">没有查询到识别码</p>
    </div>
  </a-modal>
</template>
<script>
import { getAction } from "@/api/manage";
export default {
  name: "AgentCodeSearchModal",
  data() {
    return {
      visible: false,
      eventId: '',
      keywords: '',
      codeList: null
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    search() {
        if(this.keywords == '' || this.keywords == null){
            this.$message.info("请输入关键词");
            return
        }
        getAction('/teaching/teachingAgentCode/search',{
            eventId: this.eventId,
            agentName: this.keywords
        }).then(res=>{
            if(res.success){
                this.codeList = res.result
            }
        })
    },
  },
};
</script>
<style scoped>
.qrcode {
  width: 100%;
}
</style>